export const SNOWFLAKE_GET_STATS = 'SNOWFLAKE/GET_STATS';
export const SNOWFLAKE_GET_FIRST_TIMERS = 'SNOWFLAKE/GET_FIRST_TIMERS';
export const SNOWFLAKE_GET_TERMINATED_MEMBERS =
  'SNOWFLAKE/GET_TERMINATED_MEMBERS';
export const SNOWFLAKE_SET_DATE_RANGE = 'SNOWFLAKE/SET_DATE_RANGE';
export const SNOWFLAKE_GET_LOCATIONS = 'SNOWFLAKE/GET_LOCATIONS';
export const SNOWFLAKE_SET_LOCATION = 'SNOWFLAKE/SET_LOCATION';
export const SNOWFLAKE_DOWNLOAD_REPORT = 'SNOWFLAKE/DOWNLOAD_REPORT';
